import { useEffect, useRef } from 'react';
import { ModalVariant } from 'types/Modal';
import { useUser } from 'utils/auth';
import { useModalService } from './useModalService';
import { SessionStorageKey, useSessionStorage } from './useSessionStorage';

export const useCaseMeModal = (): void => {
  const { data: user } = useUser();
  const modalService = useModalService();
  const lastHandledRef = useRef<string | null>(null);

  const cmId = sessionStorage.getItem(SessionStorageKey.CASEME_NEWSLETTER_AWAITING);
  const deferredUrlStorage = useSessionStorage<string>(SessionStorageKey.DEFERRED_URL);

  useEffect(() => {
    if (!cmId) return;
    if (lastHandledRef.current === cmId) return;

    const clearStatus = (): void => {
      sessionStorage.removeItem(SessionStorageKey.CASEME_NEWSLETTER_AWAITING);
      const deferredUrl = deferredUrlStorage.getValue();
      if (!user && deferredUrl?.includes(`cmId=${cmId}`)) {
        // TODO: Make utility function for deferred URL cleanups of global link interactions if this modal keeps be used
        const url = new URL(deferredUrl, window.location.origin);
        const searchParams = new URLSearchParams(url.search);
        searchParams.delete('cmId');
        searchParams.delete('modal');
        const newDeferredUrl =
          url.pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '');
        deferredUrlStorage.setValue(newDeferredUrl);
      }
    };

    const onRedirect = (): void => {
      sessionStorage.removeItem(SessionStorageKey.CASEME_NEWSLETTER_AWAITING);
    };

    sessionStorage.setItem(SessionStorageKey.CASEME_NEWSLETTER_TRIGGERED, cmId);
    modalService.show(ModalVariant.CASE_ME_NEWSLETTER, {
      id: cmId,
      onClose: () => {
        clearStatus();
      },
      onRedirect,
    });

    lastHandledRef.current = cmId;
  }, [cmId, deferredUrlStorage, modalService, user]);
};
